<template>
  <div v-if="azienda" class="azienda">
    <common-hero v-if="azienda.imageDesk" :background="{desktop: azienda.imageDesk.responsiveImage.src, mobile: azienda.imageMobile && azienda.imageMobile.responsiveImage ? azienda.imageMobile.responsiveImage.src : azienda.imageDesk.responsiveImage.src }"
      :scroll="true"
      :hasClass="'--vh100'"
      :tag="'div'"
    >
    </common-hero>
    <section class="padding-paragrafo padding-paragrafo--less-bottom azienda-style">
      <div class="default-container">
        <h1>{{ azienda.intro }}</h1>
        <h3 v-if="azienda && azienda.title" v-html="azienda.title.replace(/\n/g, '<br>')" />
         </div>
        </section>
         <section v-if="azienda && azienda.gallery && azienda.gallery.length > 0" class="lavorazioni-sub-tech-details">
      <ecogas-gallery :gallery="azienda.gallery" :lang="lang"/>
    </section>
    <section class="padding-paragrafo padding-paragrafo--less-top  azienda-style">
      <div class="default-container">
        <div v-html="azienda.text" />
        <LinkCta
          :to="{ name: `${lang}-contatti`, params: { lang } }"
          :label="$t('contattaci')"
        />
      </div>
    </section>

  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import CommonHero from '@/components/CommonHero'
import LinkCta from '@/components/LinkCta'
import { azienda } from '@/queries/azienda.js'
import EcogasGallery from '@/components/EcogasGallery'

export default {
  mixins: [ lang, dataLoad ],
  data: () => ({
    azienda: {},
    seo: {}
  }),
  apollo: {
    azienda: {
      query: azienda,
      fetchPolicy: 'cache-and-network',
      prefetch: true,
      variables () {
        return {
          locale: this.$i18n.locale
        }
      },
      result (result) {
        if (result.data) {
          this.azienda = result.data.azienda
          this.seo = result.data.azienda.seo
        }
      }
    }
  },
  components: {
    CommonHero,
    LinkCta,
    EcogasGallery
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .azienda-style{
    h1, h2{
      @include section-title(#343434);
      text-transform: uppercase;
      margin: 0 0 30px;
      @media #{$large_mq} {
        margin: 0 0 35px;
      }
      @media #{$xlarge_mq} {
        margin: 0 0 40px;
      }
    }
    h3 {
      font-size: 1.3rem;
      line-height: 1.3;
      font-family: 'IBM Plex Sans Condensed', sans-serif;
      font-weight: 300;
      color: #343434;
      width: 90%;
      @media #{$medium_mq} {
        font-size: 1.65rem;
      }
      @media #{$large_mq} {
        font-size: 2rem;
        width: 80%;
      }
      @media #{$xlarge_mq} {
        font-size: 2.5rem;
        width: 70%;
      }
      @media #{$xxlarge_mq} {
        font-size: 2.8125rem;
      }
      margin: 0 0 40px;
      @media #{$large_mq} {
        margin: 0 0 60px;
      }
      @media #{$xlarge_mq} {
        margin: 0 0 70px;
      }
    }
    p{
      margin: 0 0 40px;
      @media #{$large_mq} {
        margin: 0 0 60px;
      }
      @media #{$xlarge_mq} {
        margin: 0 0 70px;
      }

      font-size: 1rem;
      line-height: 1.6;
      font-family: 'IBM Plex Mono', sans-serif;
      font-weight: 400;
      color: #343434;
      width: 90%;
      @media #{$medium_mq} {
        font-size: 1.1rem;
      }
      @media #{$large_mq} {
        font-size: 1.2rem;
        width: 80%;
      }
      @media #{$xlarge_mq} {
        font-size: 1.35rem;
        width: 70%;
      }
      @media #{$xxlarge_mq} {
        font-size: 1.5rem;
      }
      strong{
        font-weight: 700;
      }
    }
    p + h2 {
      margin-top: 60px;
      @media #{$large_mq} {
        margin-top: 80px;
      }
      @media #{$xlarge_mq} {
        margin-top: 90px;
      }
    }
  }

</style>
